import React, { useImperativeHandle } from 'react'
import { saveDeal } from 'app/state/ducks/deals/thunks'
import { useDispatch } from 'react-redux'
import { useForm } from '@mantine/form'
import {
  DealParams,
  DraftDealParams
} from 'app/models/deal-params'
import { saveDealAmendment } from 'app/state/ducks/deal-amendments/thunks'
import { ErrorNotification, SuccessNotification } from '../notifications/notification'
import RichTextEditorInput from '../rich-text-editor-input/rich-text-editor-input'
import FormWrapper from '../Form/FormWrapper';



type Props = {
  deal: any
  setDeal: React.Dispatch<React.SetStateAction<any>>
  setAmendment: React.Dispatch<React.SetStateAction<any>>
  amendment?: string | null | undefined
  dealAmendment?: DraftDealParams | DealParams
  setDisabledSteps?: React.Dispatch<React.SetStateAction<number[]>>
}

type FormValues = {
  creditAgreementPreamble: string;
};

export interface ChildCreditAgreementPreambleRef {
  handleClick: () => void
}

const CreditPreambleComponent: React.ForwardRefRenderFunction<
  ChildCreditAgreementPreambleRef,
  Props
> = ({ deal, setDeal, setAmendment, amendment, dealAmendment }, ref) => {
  const dispatch = useDispatch()

  deal = dealAmendment ? dealAmendment : deal

  const form = useForm<FormValues>({
    initialValues: {
      creditAgreementPreamble: deal?.creditAgreementPreamble ?? ''
    }
  })

  const handleClick = async () => {
    let dealSubmission
    let response: any
    const submit = !form.validate().hasErrors

    if (!submit) {
      return;
    }

    const dealValues = {
      ...deal,
      creditAgreementPreamble: form.values.creditAgreementPreamble,
    }

    try {
      if (amendment) {
        const dealAmendmentId = dealAmendment?.id ?? null
        dealSubmission = saveDealAmendment(dealValues, dealAmendmentId)
      } else {
        dealSubmission = saveDeal(dealValues, deal.id)
      }

      response = await dispatch(dealSubmission)

      if (response.success) {
        if (amendment) {
          setAmendment(dealValues)
        } else {
          setDeal(dealValues)
        }
        SuccessNotification({
          title: 'Deal Updated Successfully',
          message: 'Deal Credit Agreement Preamble has been saved.',
        })
      } else {
        ErrorNotification({
          title: 'Failed to Update Deal',
          message: response.payload ?? 'Check credit agreement preamble input and try again',
        })
      }
    } catch (error) {
      ErrorNotification({
        title: 'Unexpected Error',
        message: 'Something went wrong while saving Credit Agreement Preamble: ' + error,
      })
    }
  }

  // Expose the handleClick method to the parent component
  useImperativeHandle(ref, () => ({
    handleClick,
  }))

  return (
    <FormWrapper title={"Add Credit Agreement Preamble"}>
      <div className='credit-agreement-preamble-input-wrapper' style={{ height: '100%' }}>


        <RichTextEditorInput
          form={form}
          fieldName="creditAgreementPreamble"
          placeholder="Write or paste credit agreement preamble here..."
          isMandatory={false}
          height={700}
          allowBold={false}
          allowItalic={false}
          allowUnderline={false}
          allowLink={false}
          allowUnlink={false}
          allowH1={false}
          allowH2={false}
          allowH3={false}
          allowAlignLeft={false}
          allowAlignCenter={false}
          allowAlignRight={false}
        />
      </div>
    </FormWrapper>
  )
}
export default React.forwardRef(CreditPreambleComponent)